import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessPartnerNavigationComponent } from 'app/shared/components/business-partner-navigation/business-partner-navigation.component';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/** Resolve a dot-path (e.g. `businessPartner`) from a row, or the row itself. */
function resolvePath(obj: unknown, path?: string): any {
  if (!path) return obj;
  return path.split('.').reduce<any>((acc, key) => acc?.[key], obj);
}

/**
 * SmartGrid cell renderer that navigates to a business partner master via
 * {@link BusinessPartnerNavigationComponent}. The business partner object is the
 * row itself, or a nested object addressed by `cellRendererParams.dataPath`
 * (e.g. `dataPath: 'businessPartner'` for a vehicle owner).
 */
@Component({
  selector: 'app-business-partner-nav-cell-renderer',
  standalone: true,
  imports: [CommonModule, BusinessPartnerNavigationComponent],
  template: `
    @if (businessPartner(); as bp) {
      <app-business-partner-navigation
        [businessPartner]="bp"
        displayMode="both"
        [showIcon]="true"
        interactionMode="icon-only"
        [openInNewTab]="true"
      />
    } @else {
      <span class="text-gray-400">—</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessPartnerNavCellRendererComponent {
  readonly params = input<CellRendererParams<any>>();

  readonly businessPartner = computed(() =>
    resolvePath(this.params()?.data, this.params()?.colDef?.cellRendererParams?.dataPath),
  );
}
